import React from 'react'
import StyledHeader from './MenuHeader.styles'
import MenuIcon from './MenuIcon'

export default function MenuHeader({ title, link, open, setOpen, disabled }) {
    return (
        <StyledHeader>
            {link && disabled ? (
                <a href={link}>{title}</a>
            ) : (
                <button onClick={setOpen}>
                    {title}
                    <MenuIcon open={open} />
                </button>
            )}
        </StyledHeader>
    )
}
